import $ from 'jquery';
import 'pretty-dropdowns';

/**
 * For the footer form focus state
 *
 */
const form_inputs = $('input[type="text"], input[type="email"], textarea');

form_inputs.focusin(function() {
  // this class creates the border and label animations
  // when the mouse focues in on the input field
  $(this).parents('.text-field-outline').addClass('focus');
});

form_inputs.each((index, item) => {
  if ( item.value !== '' ) {
    // this class creates the border and label animations
    // if the page reloads and the input fields has content
    $(item).parents('.text-field-outline').addClass('focus');
  }
});

form_inputs.focusout(function() {
  if ( this.value === '' ) {
    // this class creates the border and label animations
    // if there is no content in the input field once the
    // mouse loses focus then remove the focus class
    $(this).parents('.text-field-outline').removeClass('focus');
  }
});

/**
 * Change year select from 'any' to 'select year'
 *
 */
const year_select_list = $('#edit-field-year-target-id');
const year_options = $(year_select_list).find('option');

$.each(year_options, (index, item) => {
  if ( $(item).attr('value') === 'All' ) {
    $(item).html('Select Year');
  }
});

$(year_select_list).parent('.text-field-outline').find('label').addClass('screen-reader-text');

/**
 * Initialize prettyDropdown for select lists
 */
$('select').prettyDropdown({
  classic: true,
  height: 40,
  hoverIntent: 1000,
  selectedMarker: '',
  afterLoad: function() {
    // Remove the width that the plugin adds to each of these elements
    $('.prettydropdown, .prettydropdown ul, .prettydropdown li').attr('style', '');
  }
});
